import mixpanel from "mixpanel-browser"

const token = document.querySelector('meta[name="telemetry-token"]')?.content
const userId = document.querySelector('meta[name="telemetry-user-id"]')?.content
const companyId = document.querySelector('meta[name="telemetry-company-id"]')?.content

if (token && userId && companyId) {
  mixpanel.init(token, {
    track_pageview: false,
    record_sessions_percent: 100,
    record_mask_all_text: false
  })

  updateBrowserContext()
  window.addEventListener("resize", updateBrowserContext)
  window.addEventListener("orientationchange", updateBrowserContext)
  mixpanel.identify(Number(userId))
  mixpanel.set_group("company_id", Number(companyId))
  mixpanel.track_pageview({ company_id: Number(companyId) })
}

function updateBrowserContext() {
  const userAgent = navigator.userAgent
  const tablet = /iPad|Tablet|PlayBook|Silk/i.test(userAgent) ||
    (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent)) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1)
  const mobile = /Mobi|iPhone|iPod/i.test(userAgent)
  const properties = {
    device_type: tablet ? "tablet" : mobile ? "mobile" : "desktop",
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    $screen_width: window.screen.width,
    $screen_height: window.screen.height
  }

  mixpanel.register(properties, { persistent: false })

  // Share only this browser's context with subsequent server requests.
  const secure = window.location.protocol === "https:" ? "; Secure" : ""
  try {
    document.cookie = `telemetry_context=${encodeURIComponent(JSON.stringify(properties))}; Path=/; SameSite=Lax${secure}`
  } catch {
    // Browser privacy settings may block cookies without blocking analytics.
  }
}

const telemetry = {
  track(event, properties = {}) {
    if (token && userId && companyId) {
      mixpanel.track(event, properties)
    }
  }
}

export default telemetry
